import React from 'react';

interface DotNavProps {
    active: string;
    onNav: (id: string) => void;
}

export const DotNav: React.FC<DotNavProps> = ({ active, onNav }) => {
    // Reduced to 3 pages: home, specialisaties, contact (footer merged into contact)
    const dots = [
        { id: 'home', label: 'Home' },
        { id: 'specialisaties', label: 'Specialisaties' },
        { id: 'contact', label: 'Contact' }
    ];

    return (
        <nav aria-label="Sectie navigatie" className="fixed right-5 top-1/2 -translate-y-1/2 z-50 hidden md:flex flex-col space-y-3">
            {dots.map(d => (
                <button
                    key={d.id}
                    aria-label={d.label}
                    aria-current={active === d.id}
                    onClick={() => onNav(d.id)}
                    className={`w-3 h-3 rounded-full border border-[#3315e8]/40 transition-all ${active === d.id ? 'bg-[#3315e8] scale-125' : 'bg-[#3315e8]/20 hover:bg-[#3315e8]/40'}`}
                >
                    <span className="sr-only">{d.label}</span>
                </button>
            ))}
        </nav>
    );
};
